import React from 'react';
import CustomSelect from '../../../components/ui/CustomSelect';

interface Step1Props {
  formData: any;
  handleChange: (field: string, value: any) => void;
  scoringModels: any[];
  errors?: Record<string, string>;
}

export default function Step1GeneralInfo({
  formData,
  handleChange,
  scoringModels,
  errors = {},
}: Step1Props) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Jenis Permohonan <span className="text-red-500">*</span>
        </label>
        <CustomSelect
          value={formData.application_type}
          onChange={v => handleChange('application_type', v)}
          placeholder="Pilih jenis"
          width="w-full"
          error={!!errors.application_type}
          color="blue"
          options={scoringModels.map(model => ({
            value: model.credit_type || model.id,
            label: model.title || model.name,
          }))}
        />
        {errors.application_type && (
          <p className="text-sm text-red-600 mt-1">{errors.application_type}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Sistem Kredit / Pembiayaan
        </label>
        <input
          type="text"
          value={formData.credit_system}
          onChange={e => handleChange('credit_system', e.target.value)}
          placeholder="Contoh: Syariah / Konvensional"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
        />
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Jenis Debitur <span className="text-red-500">*</span>
          </label>
          <CustomSelect
            value={formData.debtor_type}
            onChange={v => handleChange('debtor_type', v)}
            placeholder="Pilih"
            width="w-full"
            error={!!errors.debtor_type}
            color="blue"
            options={[
              { value: 'individual', label: 'Perorangan' },
              { value: 'corporate', label: 'Badan Usaha' },
            ]}
          />
          {errors.debtor_type && <p className="text-sm text-red-600 mt-1">{errors.debtor_type}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Wirausaha?</label>
          <div className="flex items-center h-10 gap-3">
            <button
              type="button"
              onClick={() => handleChange('is_entrepreneur', !formData.is_entrepreneur)}
              className={`relative w-12 h-6 rounded-full transition-colors duration-200 ${
                formData.is_entrepreneur ? 'bg-blue-600' : 'bg-gray-300'
              }`}
            >
              <span
                className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow transition-transform duration-200 ${
                  formData.is_entrepreneur ? 'translate-x-6' : 'translate-x-0'
                }`}
              />
            </button>
            <span className="text-sm">{formData.is_entrepreneur ? 'Ya' : 'Tidak'}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
